export enum AmityUserBanCodes {
    GLOBAL_BAN = 400312,
    USER_IS_MUTED = 400302,
    CHANNEL_BAN = 400304,
    UNAUTHORIZED = 400100,
}

export enum AmityUserUnauthorizedCodes {
    NOT_MEMBER = 400301,
}
